import { render, staticRenderFns } from "./PredefineGroupList.vue?vue&type=template&id=975aff3a&"
import script from "./PredefineGroupList.vue?vue&type=script&lang=js&"
export * from "./PredefineGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports